import React from 'react';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { FilterFormModal } from './FilterFormModal';

export const FilterModal = () => {
	const { myFilesFilters } = useMojeSouborySeznamContext();

	if (!myFilesFilters.filterWindowOpened.value) {
		return null;
	}

	return <FilterFormModal />;
};
